import http from "../../core/services/http.service";

export default {
  getSettlementPayments(params = null) {
    return http.get(`/api/v1/settlements/settlement-payments/`, {params});
  },
};
